import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { fetchPlatformAudit } from "@/lib/platform-api";

export default function PlatformAudit() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const data = await fetchPlatformAudit(300);
      setItems(Array.isArray(data.items) ? data.items : []);
    } catch (err) {
      toast.error("Could not load audit feed", { description: err.message });
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div className="p-8 lg:p-12 max-w-[1400px] mx-auto">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <div className="text-overline">Platform</div>
          <h1 className="font-heading text-4xl mt-2 tracking-tight font-medium">Cross-tenant audit</h1>
          <p className="text-sm text-[var(--text-secondary)] mt-2">
            Recent workspace actions aggregated from tenant audit logs (newest first).
          </p>
        </div>
        <button type="button" className="btn-secondary" onClick={load} disabled={loading}>
          Refresh
        </button>
      </div>

      <div className="mt-10 overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-overline border-b" style={{ borderColor: "var(--border-default)" }}>
              <th className="py-3 pr-4">When</th>
              <th className="py-3 pr-4">Tenant</th>
              <th className="py-3 pr-4">Actor</th>
              <th className="py-3 pr-4">Action</th>
              <th className="py-3">Target</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={5} className="py-8 text-[var(--text-tertiary)]">
                  Loading…
                </td>
              </tr>
            ) : items.length === 0 ? (
              <tr>
                <td colSpan={5} className="py-8 text-[var(--text-tertiary)]">
                  No audit entries yet.
                </td>
              </tr>
            ) : (
              items.map((row, idx) => (
                <tr key={`${row.tenantId}-${row.ts}-${idx}`} className="border-b" style={{ borderColor: "var(--border-default)" }}>
                  <td className="py-3 pr-4 font-mono text-xs whitespace-nowrap">{row.ts || "—"}</td>
                  <td className="py-3 pr-4 font-mono text-xs">{row.tenantId || "—"}</td>
                  <td className="py-3 pr-4">{row.actor || "—"}</td>
                  <td className="py-3 pr-4">{row.action || "—"}</td>
                  <td className="py-3 text-[var(--text-secondary)]">{row.target || "—"}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
